export enum ViewMessageType {
  INBOX = 'inbox',
  OUTBOX = 'outbox',
  SYSTEM = 'system',
  MATCH = 'match',
  GIFT = 'gift',
  STICKER = 'sticker'
}

export enum MessageTypesUI {
  TYPE_MATCH = 'TYPE_MATCH',
  TYPE_TEXT = 'TYPE_TEXT',
  TYPE_LIKE = 'TYPE_LIKE',
  TYPE_GIFT = 'TYPE_GIFT',
  TYPE_GIFT_ACCEPT = 'TYPE_GIFT_ACCEPT',
  TYPE_GIFT_REJECT = 'TYPE_GIFT_REJECT',
  TYPE_SYSTEM_ERROR = 'TYPE_SYSTEM_ERROR',
  TYPE_SYSTEM_SUCCESS = 'TYPE_SYSTEM_SUCCESS',
  TYPE_SYSTEM_INFO = 'TYPE_SYSTEM_INFO',
  TYPE_LIKES_LIMIT = 'TYPE_LIKES_LIMIT'
}

export enum ViewPhotoState {
  APPROVE = 'approve',
  REJECT = 'reject'
}

export enum CustomDiscoveryCardHids {
  PREMIUM_UPSALE = 'premium-upsale'
}
